export default {
    conditionImport: 'เงื่อนไขการนำเข้าไฟล์',
    firstImportCondition: 'ไฟล์ต้องอยู่ในรูปเเบบของ excel รวมถึงข้อมูลพนักงาน : รหัสพนักงาน, เลขบัตรประชาชน/พาสปอร์ต, ชื่อ, นามสกุล, เพศ, วันเกิด, เเผนก, กลุ่ม, ตำเเหน่ง, อีเมล์, เบอร์โทรศัพท์, การจ้างงาน, วันที่เริ่มต้น, วันที่สิ้นสุด',
    secondImportCondition: 'หลังจากที่อัพโหลดไฟล์ excel ให้อัพโหลดข้อมูลรูปภาพใบหน้าพนักงานที่มีอยู่ในไฟล์ excel',
    thirdImportCondition: 'กรุณาตรวจสอบข้อมูลในไฟล์ excel ก่อนอัพโหลด',
    uploadFile: 'อัพโหลดไฟล์ของคุณ',
    shouldBeExcel: 'ไฟล์ต้องเป็น excel',
    dragDrop: 'ลากเเละวางไฟล์ ของคุณตรงนี้ หรือ',
    browse: 'เรียกดู',
    uploadOneFile: 'กรุณาอัพโหลดทีละไฟล์',
    wrongFileFormat: 'ประเภทไฟล์ไม่ถูกต้อง',
    uploadedFile: 'ไฟล์ที่อัพโหลดเเล้ว',
    importResult: 'ผลลัพธ์การนำเข้า'
}
